import { render, staticRenderFns } from "./purview.vue?vue&type=template&id=42b1f2be&scoped=true&"
import script from "./purview.vue?vue&type=script&lang=js&"
export * from "./purview.vue?vue&type=script&lang=js&"
import style0 from "./purview.vue?vue&type=style&index=0&id=42b1f2be&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b1f2be",
  null
  
)

export default component.exports